import jobsStyles from "./jobs.module.css";
import { IJobDescription, jobs } from "../../constants";
import React, { Dispatch, FC, SetStateAction } from "react";

interface IJobsProps {
  company: IJobDescription;
  setCompany: Dispatch<SetStateAction<IJobDescription>>;
}
const Jobs: FC<IJobsProps> = ({ company, setCompany }) => {
  return (
    <div className={jobsStyles.jobs}>
      <ul className={jobsStyles.companiesList}>
        {jobs.map((comp, index) => (
          <li key={index}>
            <button
              className={`${jobsStyles.company} ${
                comp === company ? jobsStyles.active : ""
              }`}
              onClick={() => setCompany(comp)}
            >
              {comp.company}
            </button>
          </li>
        ))}
      </ul>
      <article className={jobsStyles.job}>
        <h3 className={jobsStyles.jobTitle}>{company.description.title}</h3>
        <p className={jobsStyles.time}>{company.description.period}</p>
        {company.description.tasks.map((task, index) => (
          <p className={jobsStyles.task} key={index}>
            {task}
          </p>
        ))}
      </article>
    </div>
  );
};

export default Jobs;
